import React from "react";
import Preparar from "../../components/Preparar";
import CreateBTN from "../../components/CreateBTN";
import CheckList_Icon from "../../imgs/Icons/checklist_icon.svg";
import Submenu from "../../components/Submenu/preparar_viagem.js";
import { withNamespaces } from 'react-i18next';

// eslint-disable-next-line import/no-anonymous-default-export
const PrepararViagem_index = ({ t }) => {
  return (
    <>
      <div id="start" className="fantasmaAncora"></div>
      <div id="main">
        <Submenu />
        <CreateBTN
          link="/todolist#start"
          icon={CheckList_Icon}
          iconAlt={t('moduleBotoes:B3.Alt')}
          btnName={t('moduleBotoes:B3.B')}
        />
        <Preparar />
      </div>
    </>
  );
};
export default withNamespaces()(PrepararViagem_index);